var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isBookmark)?_c('div',{on:{"click":_vm.createBookmark}},[_c('img',{attrs:{"src":"/images/bookmark-icon.svg"}})]):_c('div',{on:{"click":_vm.deleteBookmark}},[_c('img',{attrs:{"src":"/images/bookmark-added-icon.svg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }